import styled from "styled-components";

export const CardGrid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: ${(props) => props.gridTemplateColumns};
  grid-template-areas: ${(props) => props.gridTemplateAreas};

  .recharts-wrapper > svg > g {
    outline: none !important;
  }
`;

export const Card = styled.div`
  padding: 12px 16px;
  border-radius: 5px;
  background-color: var(--color-primary-content);
  box-shadow: 0px 2px 4px 0px hsl(0 0 0 / 25%);
  grid-area: ${(props) => props.gridArea};
`;

export const CardHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const CardTitle = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 18px;
`;

export const CardSubTitle = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 12px;
`;

export const CardAction = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 20px;
`;

export const CardBody = styled.div``;
export const CardMetric = styled.div`
  font-family: Inter;
  font-weight: 700;
  font-size: 36px;
  line-height: 40px;
`;
export const CardSubText = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  padding: 4px 2px;
`;
export const CardSpacer = styled.div`
  height: 48px;
  width: 1px;
  margin: 0px 0px;
  background-color: hsl(0 0 0 / 20%);
`;
